import { Swiper, SwiperSlide } from 'swiper/react';
import { Autoplay } from 'swiper/modules';
import 'swiper/css';
import { Box } from '@mui/material';
import { StyledImage } from './ImageCarousel.style';
import { TOneBoxV2GetNotificationImageDetail } from '~/api/oneBoxV2/oneBoxV2.type';

type TProps = {
  imgList: TOneBoxV2GetNotificationImageDetail[];
};

export const ImageCarousel = ({ imgList }: TProps) => {
  return (
    <Box>
      {imgList.length === 0 ? null : (
        <Swiper
          spaceBetween={30}
          centeredSlides={true}
          autoplay={{
            disableOnInteraction: false,
          }}
          loop={true}
          modules={[Autoplay]}
          style={{ width: '100%', height: '100%' }}
        >
          {imgList.map((img, index) => (
            <SwiperSlide key={index} data-swiper-autoplay={`${img.seconds}000`}>
              <StyledImage key={img.id} src={img.imgUrl} alt={img.id} />
            </SwiperSlide>
          ))}
        </Swiper>
      )}
    </Box>
  );
};
